import clsx from "clsx";

import { type DataTypeProvider } from "@devexpress/dx-react-grid";

export const MetricDataFormatter = ({
  column,
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  return (
    <div className="flex items-center justify-between h-full px-2 w-full">
      <div
        className={clsx(
          "flex flex-col flex-grow font-mono metric-content truncate",
        )}
      >
        <div className="text-right truncate">{row.metrics[column.name]}</div>
      </div>
    </div>
  );
};
